document.addEventListener('readystatechange', () => {
    if (document.readyState !== 'complete') return;

    let header = document.querySelector('.diu-neos-structure-header');

    if (header) {
        window.addEventListener('scroll', function () {
            let scroll = window.scrollY;
            if (scroll > 0) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
        });
    }
});
